import { render, staticRenderFns } from "./LomTrainingApproval.vue?vue&type=template&id=57c7fc20&scoped=true"
import script from "./LomTrainingApproval.vue?vue&type=script&lang=js"
export * from "./LomTrainingApproval.vue?vue&type=script&lang=js"
import style0 from "./LomTrainingApproval.vue?vue&type=style&index=0&id=57c7fc20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c7fc20",
  null
  
)

export default component.exports